module.exports = __webpack_public_path__ + "static/bg_stepts.min-953bc2758c015013e20db589788853fe.png";